import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getAuthToken } from '../../utils/auth';

export const PublicRoute = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const hasChild = searchParams.has('child');

  if (getAuthToken() && !hasChild) {
    return <Navigate to={'/'} />;
  }

  return <Outlet />;
};
